import type { ActionButtonProps } from '../../commandActions/types'
import { EmployerAgreementCommandNester } from '../EmployerAgreementCommandNester'
import { AmendEmployerAgreementPoliciesNestedCommand } from './AmendEmployerAgreementPoliciesNestedCommand'

export const AmendEmployerAgreementPoliciesCommand = (
  props: ActionButtonProps,
) => (
  <EmployerAgreementCommandNester
    NestedCommand={AmendEmployerAgreementPoliciesNestedCommand}
    {...props}
  />
)
